import { Component, OnInit, ChangeDetectionStrategy, ChangeDetectorRef } from '@angular/core';
import { BannerService } from './../../services/banner/banner.service';

@Component({
  selector: 'app-banner',
  templateUrl: './banner.component.html',
  styleUrls: ['./banner.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BannerComponent implements OnInit {

  bannersOptions: any = {
    loop: true,
    dots: false,
    navSpeed: 700,
    navText: ['<i class="flaticon-back"></i>', '<i class="flaticon-next"></i>'],
    items: 1,
    nav: true
  };

  banners: any;

  constructor(
    private bannerService: BannerService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.bannerService.getBanners().subscribe((banners) => {
      this.banners = banners;
      this.cdr.markForCheck();
    });
  }

}
